import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { FeedbackModel } from '../../../../models/feedback.model';
import { AlertService } from '../../../../services/alert.service';
import { ContactService } from '../../../../services/contact.service';
import { UserService } from '../../../../services/user.service';
import {
  fieldRequired,
  getMaxLengthFromValidator,
  getTextAreaLength,
} from '../../../../utils/form.utils';
import { CaptchaComponent } from '../../../shared-components/captcha/captcha.component';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
  standalone: false,
})
export class ContactComponent {
  public isLoading = false;
  public contactForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    subject: new FormControl('', [Validators.required]),
    message: new FormControl('', [
      Validators.required,
      Validators.maxLength(1200),
    ]),
    privacyConfirmation: new FormControl(false),
  });
  public fieldRequired = fieldRequired;
  public getTextAreaLength = getTextAreaLength;
  public getMaxLengthFromValidator = getMaxLengthFromValidator;

  constructor(
    private contactService: ContactService,
    private alertService: AlertService,
    private dialogService: DialogService,
    public userService: UserService
  ) {}

  public ngOnInit(): void {
    if (!this.userService.currentUser$.value) {
      this.contactForm
        .get('privacyConfirmation')
        .setValidators([Validators.requiredTrue]);
      this.contactForm.get('privacyConfirmation').updateValueAndValidity();
    }
  }

  public submit(): void {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      this.alertService.showErrorAlert('Bitte fülle alle Felder aus.');
      return;
    }
    const feedback: FeedbackModel = {
      firstName: this.contactForm.get('firstName').value,
      lastName: this.contactForm.get('lastName').value,
      email: this.contactForm.get('email').value,
      subject: this.contactForm.get('subject').value,
      message: this.contactForm.get('message').value,
    };

    const dialogRef = this.dialogService.open(CaptchaComponent, {
      header: 'Captcha',
      width: '450px',
    });
    dialogRef.onClose.subscribe(result => {
      if (result) {
        this.sendContactMail(feedback);
      }
    });
  }

  public sendContactMail(feedback: FeedbackModel): void {
    this.isLoading = true;
    // send feedback
    this.contactService.sendContactMail(feedback).subscribe({
      next: () => {
        this.contactForm.reset();
        this.alertService.showSuccessAlert(
          'Ihre Nachricht wurde erfolgreich gesendet.'
        );
        this.isLoading = false;
      },
      error: () => {
        // show error message
        this.alertService.showErrorAlert(
          'Die konnte leider nicht gesendet werden. Bitte versuchen Sie es später erneut.'
        );
        this.isLoading = false;
      },
    });
  }
}
